import { render } from "./PlotlyChart.vue?vue&type=template&id=32851870&scoped=true"
import script from "./PlotlyChart.vue?vue&type=script&lang=js"
export * from "./PlotlyChart.vue?vue&type=script&lang=js"

import "./PlotlyChart.vue?vue&type=style&index=0&id=32851870&scoped=true&lang=css"
import "./PlotlyChart.vue?vue&type=style&index=1&id=32851870&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32851870"]])

export default __exports__